export default __webpack_public_path__ + "static/envelove-5eb1b2103ce7f02f49edfbb8870b8d47.jpg";